import React from "react";
import { FaArrowLeft } from "react-icons/fa";

const CustomLeftArrow = () => {
  return (
    <div className="relative xl:top-20 lg:top-16 md:top-5 sm:top-20">
      <FaArrowLeft className="cursor-pointer" />
    </div>
  );
};

export default CustomLeftArrow;
